import { Helmet } from "react-helmet";
import Footer from "../components/footer";
import Header from "../components/header";
import TopNavabr from "../components/topNavabr";
import appStoreBannerImg from "../images/app-store/app-store-banner.webp";
import benifity from "../images/app-store/benifity.webp";
import cloudPrint from "../images/app-store/cloud-print.webp";
import websiteDashboard from "../images/app-store/employee-dashboard.webp";
import financialDashboard from "../images/app-store/financial-dashboard.webp";
import reward from "../images/app-store/rewards.webp";
import SegamCard from "../images/app-store/segam-card.webp";
import tawqiImg from "../images/app-store/sign-it.png";
import supportCenter from "../images/app-store/support-center.webp";
import tenderly from "../images/app-store/tenderly.webp";
import ustaze from "../images/app-store/ustaze.webp";
import webMaster from "../images/app-store/web-master.webp";

const websitesData = [
  {
    title: "Web Master",
    subtitle: "Manage Website",
    description:
      "Dynamic Content Management System for Admin & Project management.",
    link: "https://backend.afro-group.com/",
    image: webMaster,
  },
  {
    title: "Employee Dashboard",
    subtitle: "Human Resources",
    description:
      "All employees can manage their files, work journals and other tools.",
    link: "",
    image: websiteDashboard,
  },
  {
    title: "Aemali",
    subtitle: "IT Department",
    description:
      "Aemali Support Ticketing System to track requests and solves the issues...",
    link: "https://aemali.com",
    image: supportCenter,
  },
  {
    title: "Tawqi App",
    subtitle: "Smart Digital Signature",
    description:
      "Create email signatures, smart QR signature simply in two steps...",
    link: "https://tawqi.afro-group.com",
    image: tawqiImg,
  },
  {
    title: "Cloud Print",
    subtitle: "IT Department",
    description:
      "Print from anywhere. Connects to Afro cloud printing center. Track quotas & much more...",
    link: "https://cloudprint.afro-group.net",
    image: cloudPrint,
    linkText: "Visite",
  },
  {
    title: "AFRO Rewards",
    subtitle: "Human Resources",
    description:
      "Rewards & recognition promotes employee engagement and retention...",
    link: "",
    image: reward,
  },
  {
    title: "Tenderly",
    subtitle: "Supply Chain",
    description: "Vendor tender management and RFQ awards and management.",
    link: "",
    image: tenderly,
  },
  {
    title: "Financial Dashboard",
    subtitle: "Finance Department",
    description:
      "Visualize, track & consolidate reports on Financial & Treasury performance.",
    link: "",
    image: financialDashboard,
  },
  {
    title: "Benifity",
    subtitle: "Personal Networking",
    description:
      "Digital NFC tech to network, manage your personal brand & online presence...",
    link: "https://benifity.com",
    image: benifity,
  },
  {
    title: "Ustaze",
    subtitle: "Learning & Development",
    description:
      "Master real, in-demand skills with industry experts for jobs of the future.",
    link: "https://ustaze.com",
    image: ustaze,
  },
  {
    title: "Segam Group",
    subtitle: "Feeding the future",
    description: "Trusted source for sustainable contract farming solutions.",
    link: "https://segamgroup.com",
    image: SegamCard,
    linkText: "Visite",
  },
];

export default function AppStore() {
  return (
    <>
      <Helmet>
        <title>AFRO || App Store</title>
      </Helmet>
      <TopNavabr />
      <Header
        bannerBackground="image"
        videoURL=""
        imageURL=""
        staticImageURL={appStoreBannerImg}
      >
        <div className="pt-7 pb-5 text-center">
          <h1 className="fs-56 mt-4 text-capitalize flex align-items-center header-background-image-size">
            Enterprise App Store
          </h1>
        </div>
      </Header>
      <div className="container-fluid pt-7 pb-7">
        <div className="ms-13 me-13">
          <div className="container">
            <div className="row">
              {websitesData.map((website, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-4 h-100">
                  <div className="review-shadow bg-white rounded-lg cursor-pointer transform-up my-4 position-relative pb-4">
                    <div>
                      <img
                        src={`${website?.image}`}
                        alt={website?.title}
                        style={{
                          borderRadius: "10px 10px 0 0",
                        }}
                        className="img-fluid"
                      />
                      <div className="p-3">
                        <span>{}</span>
                        <h3 className="fs-24 my-3 text-capitalize text-charleston-green gilroy-bold">
                          {website?.title}
                        </h3>
                        <h4 className="fs-18 my-3 text-capitalize text-orange-ryb gilroy-bold">
                          {website?.subtitle}
                        </h4>
                        <p className="fs-16 text-secondary">
                          {website?.description}
                        </p>
                        {website?.link !== "" ? (
                          <a
                            className="fs-16 text-dark text-decoration-none visit-button gilroy-bold"
                            href={website?.link}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {website?.linkText ? website?.linkText : "Login"}{" "}
                            <span className="arrow-icon fs-16">&rarr;</span>
                          </a>
                        ) : (
                          <p className="fs-16 text-dark gilroy-bold mb-0 pb-0">
                            <span class="">Coming soon...</span>
                          </p>
                        )}
                        <div className="review-card-border"></div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
